import HttpService from './http.service';

class LogService {
  getLogs(params) {
    return HttpService.get('logs', {
      params,
    })
      .then((res) => res.data);
  }
}

export default new LogService();
